<template>
	<div class="flex flex-col md:flex-row md:space-x-4 max-w-4xl items-start px-4">

		<div class="card flex-1 card-white mx-auto rounded-xl w-full order-1 md:order-0 my-4 md:my-0">
			<h1 class="text-2xl font-bold mb-8">Настройки</h1>

			<div v-if="!section" class="space-y-4">
				<formcontrol
					type="textarea"
					label="Описание профиля"
					v-model="form.user.description"
					hint="Это описание будет выводиться в вашем профиле"
				></formcontrol>

				<formcontrol
					control-type="email"
					:required="true"
					label="Email"
					v-model="form.user.email"
					hint="Указывайте реальную почту, она используется для уведомлений и восстановления пароля"
				></formcontrol>

				<formcontrol
					type="dropdown"
					label="Лента по умолчанию"
					:options="feeds"
					v-model="form.feed"
				></formcontrol>

				<formcontrol
					type="dropdown"
					label="Режим"
					:options="darkmodes"
					v-model="form.dark_mode"
				></formcontrol>

				<div class="pt-6">
					<button @click="save" class="btn btn-md btn-primary">Сохранить</button>
				</div>
			</div>

			<div v-if="section === 'notifications'" class="space-y-2">
				<div class="flex space-x-2 items-center text-sm text-gray-300 dark:text-slate-500 mb-3">
					<div class="flex-1">Тип уведомлений</div>
					<div class="w-10 shrink-0 text-center" title="Уведомления в колокольчик">
						<svg-icon icon="bell-fill" class="w-3 h-3 mx-auto"></svg-icon>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0 text-center"
						 title="Уведомления в телеграм">
						<svg-icon icon="telegram" class="w-3 h-3 mx-auto"></svg-icon>
					</div>
					<div class="w-10 shrink-0 text-center"
						 title="Push">
						<svg-icon icon="browser-chrome" class="w-3 h-3 mx-auto"></svg-icon>
					</div>
				</div>

				<div class="flex space-x-2 items-center">
					<div class="flex-1">Ответы на мои комментарии</div>
					<div class="w-10 shrink-0 text-center">
						<formcontrol v-model="form.notifications.types.comment_reply.database" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.comment_reply.telegram" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.comment_reply.webpush" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
				</div>

				<div class="flex space-x-2 items-center">
					<div class="flex-1">Оценки ваших записей</div>
					<div class="w-10 shrink-0 text-center">
						<formcontrol v-model="form.notifications.types.post_like.database" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.post_like.telegram" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.post_like.webpush" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
				</div>

				<div class="flex space-x-2 items-center">
					<div class="flex-1">Оценки ваших комментариев</div>
					<div class="w-10 shrink-0 text-center">
						<formcontrol v-model="form.notifications.types.comment_like.database" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.comment_like.telegram" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.comment_like.webpush" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
				</div>

				<div class="flex space-x-2 items-center">
					<div class="flex-1">Новые комментарии к постам</div>
					<div class="w-10 shrink-0 text-center">
						<formcontrol v-model="form.notifications.types.post_comment.database" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.post_comment.telegram" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.post_comment.webpush" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
				</div>

				<div class="flex space-x-2 items-center">
					<div class="flex-1">Новые посты-ответы к моим постам</div>
					<div class="w-10 shrink-0 text-center">
						<formcontrol v-model="form.notifications.types.post_reply.database" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.post_reply.telegram" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>

					<div class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.post_reply.webpush" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
				</div>

				<div class="flex space-x-2 items-center">
					<div class="flex-1">Новые посты в блогах пользователей и подсайтов, на которые я подписан</div>
					<div class="w-10 shrink-0 text-center">
						<formcontrol v-model="form.notifications.types.post_published.database" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.post_published.telegram" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>

					<div class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.post_published.webpush" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
				</div>

				<div class="flex space-x-2 items-center">
					<div class="flex-1">Новые подписчики</div>
					<div class="w-10 shrink-0 text-center">
						<formcontrol v-model="form.notifications.types.subscriber_added.database" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.subscriber_added.telegram" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>

					<div class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.subscriber_added.webpush" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
				</div>

				<div class="flex space-x-2 items-center">
					<div class="flex-1">Упоминания</div>
					<div class="w-10 shrink-0 text-center">
						<formcontrol v-model="form.notifications.types.user_mentioned.database" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div v-if="form.telegram && form.telegram.telegram_user_id" class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.user_mentioned.telegram" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
					<div class="w-10 shrink-0  text-center">
						<formcontrol v-model="form.notifications.types.user_mentioned.webpush" type="toggle"
									 class="inline-flex"></formcontrol>
					</div>
				</div>

				<div class="pt-4">
					<formcontrol v-model="form.notifications.settings.subscribe_for_comments_to_own_posts"
								 class="toggle" type="toggle"
								 label="Подписываться на ВСЕ комментарии к своим постам"></formcontrol>

					<formcontrol v-model="form.notifications.settings.sound" class="toggle" type="toggle"
								 label="Проигрывать звук при получении уведомления"></formcontrol>

					<formcontrol v-model="form.notifications.settings.mark_as_read" class="toggle"
								 type="toggle" label="Помечать уведомления прочитанными при открытии колокольчика"
					></formcontrol>

					<div class="mt-4">
						<div v-if="push.isBrowserSupportsNotifications()"
							 @click="togglePush(!hasPushSubscription)"
							 class="btn cursor-pointer space-x-2 btn-sm btn-default items-center">
							<svg-icon v-if="hasPushSubscription" icon="toggle-on" class="w-3 h-3"></svg-icon>
							<svg-icon v-else icon="toggle-off" class="w-3 h-3"></svg-icon>
							<div v-if="hasPushSubscription">Выключить пуш-уведомления в браузере</div>
							<div v-else>Включить пуш-уведомления в браузере</div>
						</div>
						<div v-else class="alert alert-danger text-xs">
							Ваш браузер не поддерживает пуш уведомления
						</div>
					</div>
				</div>
			</div>

			<div v-if="section === 'telegram'" class="space-y-6">
				<div class="alert alert-info">
					Вы можете привязать свой аккаунт в телеграме и получать выбранные типы уведомлений в
					<a href="https://t.me/gonkong_me_bot" target="_blank">бот Гонконга</a>.
				</div>

				<div v-if="form.telegram && form.telegram.telegram_user_name">
					<div class="mb-2">Привязан аккунт:</div>

					<div class="flex items-center space-x-2">
						<a :href="'https://telegram.me/' + form.telegram.telegram_user_name" target="_blank">
							@{{ form.telegram.telegram_user_name }}
						</a>
						<span @click="telegramDisconnect" class="btn btn-danger btn-sm p-1 cursor-pointer">
                        <svg-icon icon="dash-circle" class="w-3 h-3"></svg-icon>
                     </span>
					</div>
				</div>

				<div v-else>
					<div class="mb-4">Вы еще не подключили бота</div>
					<a :href="'https://telegram.me/gonkong_me_bot?start=' + form.telegram.unique_code"
					   target="_blank" class="btn btn-md btn-primary">
						Подключить бота
					</a>
				</div>

			</div>

			<div v-if="section === 'password'" class="space-y-4">
				<div class="text-xl">
					Смена пароля
				</div>

				<formcontrol
					control-type="password"
					:required="true"
					label="Текущий пароль"
					v-model="password.old_password"
				></formcontrol>

				<formcontrol
					control-type="password"
					:required="true"
					label="Новый пароль"
					v-model="password.new_password"
					hint="Новый пароль должен быть не менее 8 символов длиной"
				></formcontrol>

				<formcontrol
					control-type="password"
					:required="true"
					label="Введите новый пароль еще раз"
					v-model="password.new_password_confirmation"
				></formcontrol>

				<div class="pt-6">
					<button @click.prevent="changePassword" :disabled="!isPasswordFieldFilled" class="btn btn-danger">
						Сменить пароль
					</button>
				</div>
			</div>

			<div v-if="section === 'invites'" class="space-y-4">
				<div class="text-xl">
					Инвайты
				</div>

				<div class="text-sm">
					Мы ценим твой вклад в развитие Гонконга и хотим чтобы к нам приходили лучшие из лучших.
					Мы уверены, что ты не один такой, и у тебя есть такие же друзья,
					которые отлично впишутся в наш узкий, тесный, но приятный Гонконг.
					Поэтому иногда мы будем выдавать тебе и другим классным пользователям некоторое количество инвайтов,
					с помощью которых ты сможешь пригласить сюда других классных людей.
					Заглядывай сюда иногда чтобы проверить не появились ли у тебя новые инвайты.
				</div>

				<div class="alert alert-success">
					Тебе доступно инвайтов: <strong>{{ form.user.invites_count }}</strong>
				</div>

				<div v-if="form.user.invites_count > 0" class="space-y-4 pt-6">
					<div class="text-xl">
						Есть кто-то на примете? Давай пригласим его!
					</div>

					<div>
						Мы в ответе за тех, кого пригласили. Если твой приглашенный друг будет портить нам жизнь,
						то это может отразиться и на тебе тоже, поэтому будь мудр, дальновиден и ответственен.
					</div>

					<formcontrol
						control-type="email"
						:required="true"
						label="Email твоего знакомого"
						v-model="form.invite.email"
						placeholder="genius@email.com"
					></formcontrol>

					<div class="pt-6">
						<button @click.prevent="sendInvite" :disabled="!emailValid(form.invite.email)"
								class="btn btn-danger">
							Отправить инвайт
						</button>
					</div>
				</div>
			</div>

			<div v-if="section === 'suicide'" class="space-y-4 relative">

				<div class="text-sm">
					Никакого суецыда. Но если тебе нужно отдохнуть или почистить совесть,
					у нас есть несколько вариантов. Имей в виду, что эти действия необратимы.
					Фарш невозможно провернуть назад. Хорошо подумай, прежде чем нажимать эти ссылки
				</div>

				<div class="flex flex-col gap-2">
					<a href="#" @click.prevent="deletePosts"
					   class="flex items-center gap-2 text-red-500 p-1 px-2 hover:bg-gray-500/10 rounded">
						<svg-icon icon="file-post-fill" class="w-4 h-4 shrink-0"/>
						<span>Удалить все мои посты</span>
					</a>
					<a href="#" @click.prevent="deleteComments"
					   class="flex items-center gap-2 text-red-500 p-1 px-2 hover:bg-gray-500/10 rounded">
						<svg-icon icon="chat-fill" class="w-4 h-4 shrink-0"/>
						<span>Удалить все мои комментарии</span>
					</a>
					<a href="#" @click.prevent="deactivateAccount"
					   class="flex items-center gap-2 text-red-500 p-1 px-2 hover:bg-gray-500/10 rounded">
						<svg-icon icon="person-x-fill" class="w-4 h-4 shrink-0"/>
						<span>Деактивировать профиль</span>
					</a>
				</div>

				<div v-if="loading"
					 class="absolute inset-0 z-100 flex items-center justify-center bg-white/20 dark:bg-slate-900/20 text-gray-500">
					Скоро все будет. Нужно только подождать.
				</div>
			</div>
		</div>

		<div class="card card-white mx-auto max-w-4xl p-2 rounded-xl w-full md:w-60 space-y-0.5 order-0 md:order-1">
			<div v-for="(label, key) in items" :key="key"
				 @click="setSection(key, true)"
				 class="cursor-pointer p-2 px-3 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700"
				 :class="{'bg-gray-200 hover:bg-gray-200 dark:bg-slate-600 dark:hover:bg-slate-600' : section === key}"
			>
				{{ label }}
			</div>
		</div>
	</div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import User from "../../js/modules/User";
import WebPush from "../../js/modules/WebPush";

export default {
	props: ['part', 'url'],
	data() {
		let user = new User();
		let userData = user.data();
		let settings = user.settings();
		const push = new WebPush();

		push.hasSubscription(hasSubscription => {
			this.hasPushSubscription = hasSubscription;
		});

		return {
			timeout: null,
			push: push,
			hasPushSubscription: false,
			pushServiceWorkerRegistered: false,
			user: user,
			section: this.part ?? '',
			loading: false,
			items: {
				'': 'Настройки',
				notifications: 'Уведомления',
				telegram: 'Привязка Telegram',
				password: 'Смена пароля',
				invites: 'Инвайты',
				suicide: 'Суицид',
			},
			form: {
				user: {
					email: userData.email,
					invites_count: userData.invites_count,
					description: userData.description,
				},
				invite: {
					email: '',
				},
				show_mobile_timeline: settings.show_mobile_timeline ?? 0,
				feed: settings.feed ?? '',
				dark_mode: settings.dark_mode ?? 'light',
				notifications: settings.notifications,
				telegram: userData.telegram,
			},
			feeds: [
				{value: '', label: 'Популярное'},
				{value: 'feed', label: 'Моя лента'},
				{value: 'fresh', label: 'Свежее'},
			],
			darkmodes: [
				{value: 'light', label: 'Светлая тема'},
				{value: 'dark', label: 'Темная тема'},
				{value: 'system', label: 'Как в системе'},
			],
			password: {
				old_password: '',
				new_password: '',
				new_password_confirmation: '',
			}
		};
	},
	watch: {
		'form': {
			handler: function (val) {
				this.save();
			},
			deep: true
		}
	},
	mounted() {
		window.addEventListener("popstate", (event) => {
			if (event.state && event.state.section) {
				this.setSection(event.state.section);
			} else {
				this.setSection('');
			}
		});
	},
	methods: {
		setSection(section, setState = false) {
			this.section = section;

			if (setState) {
				let url = this.url + (section ? '/' + section : '');
				window.history.pushState({section: section}, null, url);
			}
		},
		save() {
			if (this.timeout) {
				clearTimeout(this.timeout);
			}

			this.timeout = setTimeout(() => {
				Client.post('/api/v1.1/settings', this.form)
					.then(response => {

						this.user.update(response.data.data);

						notify({
							type: 'success',
							text: 'Сохранено',
						});
					})
					.catch(error => {
						notify({
							type: 'error',
							text: 'Я не смог сохранить. Прости',
						});
					});
			}, 1000);
		},
		get(obj, key) {
			return key.split(".").reduce(function (o, x) {
				return (typeof o == "undefined" || o === null) ? o : o[x];
			}, obj);
		},
		telegramDisconnect() {
			Client.delete('/api/v1.1/settings/telegram')
				.then(response => {
					this.form.telegram = response.data;

					notify({
						type: 'success',
						text: 'Аккаунт отвязан',
					});
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Не вышло. Пиши зоебане, он починит',
					});
				})
		},
		emailValid(email) {
			return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
		},
		sendInvite() {
			if (this.form.invite.email && this.emailValid(this.form.invite.email)) {
				Client.post('/api/v1.1/user/invite', {
					email: this.form.invite.email,
				})
					.then(response => {
						this.form.user.invites_count = response.data.invites_count;
						this.form.invite.email = '';

						notify({
							type: 'success',
							text: 'Инвайт отправлен',
						});
					})
					.catch(error => {
						let errors = error.response.data.errors;
						Object.values(errors).forEach((error) => {
							notify({
								type: 'error',
								text: error[0],
							});
						});
					})
			}
		},
		changePassword() {
			if (confirm('Вы уверены, что хотите изменить пароль?')) {
				Client.patch('/api/v1.1/user/password', this.password)
					.then(response => {
						this.password.old_password = '';
						this.password.new_password = '';
						this.password.new_password_confirmation = '';

						notify({
							type: 'success',
							text: 'Пароль изменен',
						});
					})
					.catch(error => {
						let errors = error.response.data.errors;
						Object.values(errors).forEach((error) => {
							notify({
								type: 'error',
								text: error[0],
							});
						});
					})
			}
		},
		togglePush() {
			if (this.hasPushSubscription) {
				this.push.register()
					.then((registration) => {
						this.hasPushSubscription = false;
						registration.update();
						this.push.unsubscribeUser();
					});
			} else {
				this.push.register()
					.then((registration) => {
						registration.update();
						this.push.requestPermission();
						this.hasPushSubscription = true;
					});
			}
		},
		deletePosts() {
			if (!confirm('Хорошо подумай. Все, что ты писал(а) на ГК, исчезнет в бездне под влиянием сиюминутных эмоций и гормонов. Ты уверен(а)?')) {
				notify({
					type: 'success',
					text: 'Молодец! Так держать! Я горжусь тобой!',
				});
				return;
			}

			this.loading = true;
			Client.delete('/api/v1.1/user/posts')
				.then(response => {
					notify({
						type: 'success',
						text: 'Порвался, жаль. Посты будут удалены в течение 10 минут',
					});
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Даже сервер отказывается это делать, выбрасывая ошибку. Возможно, это знак свыше. Фиксики починят, но у тебя будет время подумать',
					});
				})
				.finally(() => {
					this.loading = false;
				})
		},
		deleteComments() {
			if (!confirm('Хорошо подумай. Все, что ты комментировал(а) на ГК, исчезнет в бездне под влиянием сиюминутных эмоций и гормонов. Ты уверен(а)?')) {
				notify({
					type: 'success',
					text: 'Молодец! Так держать! Я горжусь тобой!',
				});
				return;
			}

			this.loading = true;
			Client.delete('/api/v1.1/user/comments')
				.then(response => {
					notify({
						type: 'success',
						text: 'Порвался, жаль. Все комменты удалены',
					});
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Даже сервер отказывается это делать, выбрасывая ошибку. Возможно, это знак свыше. Фиксики починят, но у тебя будет время подумать',
					});
				})
				.finally(() => {
					this.loading = false;
				})
		},
		deactivateAccount() {
			if (!confirm('Хорошо подумай. Профиль будет отключен и ты потеряешь доступ к нему. Ты уверен(а)?')) {
				notify({
					type: 'success',
					text: 'Молодец! Так держать! Я горжусь тобой!',
				});
				return;
			}

			this.loading = true;
			Client.delete('/api/v1.1/user/profile')
				.then(response => {
					notify({
						type: 'success',
						text: 'Порвался, жаль. Профиль отключен. Прощай',
					});
				})
				.catch(error => {
					notify({
						type: 'error',
						text: 'Даже сервер отказывается это делать, выбрасывая ошибку. Возможно, это знак свыше. Фиксики починят, но у тебя будет время подумать',
					});
				})
				.finally(() => {
					this.loading = false;
				})
		},
	},
	computed: {
		isPasswordFieldFilled() {
			return this.password.old_password !== ''
				&& this.password.new_password.length >= 8
				&& this.password.new_password_confirmation.length >= 8
				&& this.password.new_password === this.password.new_password_confirmation;
		}
	}
}
</script>
